import React,{useEffect,useState} from "react";


import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


import BodyHeader from "./components/body_header"
import BodyParagraph from "./components/body_paragraph"


import {isMobile} from "react-device-detect";

import Overlay from "./components/overlay"
import ImpactBox from "./components/impact_box"
import ResearchImpact from "./components/research_impact"
import QuoteSection from "./components/quote-section"

import {research_data as data} from "../store"
import {triangle} from "../../static/images"

const vidUrl="https://www.youtube.com/embed/njxVtoS_xz8"


export default function Research(props){
    const {onCloseCallback,onOpenCallback,show,setShow,persona}=props;

    const personaKey = Number.isInteger(persona) && Object.prototype.hasOwnProperty.call(data, persona)
        ? persona
        : 0;
    const personaData = data[personaKey] || data[0];

    const [content, setContent] = useState(<></>);

    const [selected,setSelected]=useState(undefined)

    const [studyTypeBranch,setStudyBranch]=useState(0);

    const [boxWidth,setBoxWidth]=useState(150);


    useEffect(() => {
        
        const changeBoxWidth=()=>{
            
            if(window.innerWidth>=992){
                setBoxWidth(150);
            }
            else if(window.innerWidth>=768){
                setBoxWidth(125);
            }
            else{
                setBoxWidth(100);
            }
        }
        changeBoxWidth();

        window.addEventListener('resize',changeBoxWidth);
        return () => {
            window.removeEventListener('resize',changeBoxWidth);
        };
    }, []);

   

    function reset(){
        setStudyBranch(0);
        setSelected(undefined);
    }

    useEffect(() => {
        reset();
    }, [personaKey]);

    useEffect(() => {
        let impactBoxes=[];
        if(personaKey===2){
            const colNum=3;
            const rowNum=Math.ceil(personaData.impactsShort.length/colNum) 
            // console.log("rowNum: "+rowNum);

            for (var i=0;i<rowNum;i++){
                let boxes=[];

                for(var j=0;j<colNum;j++){
                    const row=i;
                    const col=j;
                    const index=3*row+col;

                    boxes.push(
                    <Col 
                    
                    key={`box-${index}`} 
                    className="p-0 m-2">
                        <ImpactBox 
                        onClick={()=>{setSelected(index);}} 
                        name={personaData.impactsShort[i*3+j]}
                        topLeftCorner={row===0&&col===0}
                        topRightCorner={row===0&&col===colNum-1}
                        bottomLeftCorner={row===rowNum-1&&col===0}
                        bottomRightCorner={row===rowNum-1&&col===colNum-1}
                        ></ImpactBox>
                    </Col>)
                }

                impactBoxes.push(<Row key={`boxes-row-${i}`}>
                    {boxes}
                </Row>)
            }
        }
        
        let studyTypeBoxes;
        let studyTypeCol;
        if(selected!==undefined && personaData.studies[selected] && personaData.studies[selected].length>1){
            studyTypeBoxes=personaData.studies[selected].map((type,index)=>{
                return (
                
                    <Col xs="auto" key={`type-box-${index}`} className="pr-0">
                    <ImpactBox 
                    
                    onClick={()=>{setStudyBranch(index)}} 
                    topLeftCorner={index===0} 
                    bottomLeftCorner={index===0} 
                    topRightCorner={index===personaData.studies[selected].length-1} 
                    bottomRightCorner={index===personaData.studies[selected].length-1} 
                    name={type}
                    selected={index===studyTypeBranch}
                    />
                    </Col>
                       
                )
            })

            studyTypeCol=(<Col xs={{span:10,offset:1}}  className={`p-0 mb-1`}>
                <Row>
                    {studyTypeBoxes}
                </Row>
                
            </Col>)
        }
        

        
            switch(personaKey){
                case 0:
                    setContent(
                    <>
                        <Row className="w-100">
                            <BodyHeader header={personaData.bHeaders[0]}></BodyHeader>
                        </Row>
                        <Row className="w-100">
                            <QuoteSection quote={personaData.quotes[0].quote} author={personaData.quotes[0].author}></QuoteSection>
                        </Row>
        
                        <Row className="w-100 mt-3">
                            <BodyParagraph paragraph={personaData.bParas[0]}></BodyParagraph>
                        </Row>
                    </>)
                    break;
                case 1:
                
                setContent(<>
                    <Row className="w-100">
                        <BodyHeader header={personaData.bHeaders[0]}></BodyHeader>
                    </Row>
                    <Row className="w-100">
                        <BodyParagraph paragraph={personaData.bParas[0]}></BodyParagraph>
                    </Row>
                    <Row className="w-100">
                        <BodyHeader colClass="mt-4" header={personaData.bHeaders[1]}></BodyHeader>
                    </Row>
                    
                    <Row className="w-100">
                    <BodyParagraph  paragraph={personaData.bParas[1]}>
                    </BodyParagraph>
                    </Row>
                
                    <Row className="w-100">
                    <Col xs={{span:10,offset:1}}>
                        <div className="aspect-ratio-16-9">
                            <iframe title="From Strength to Strength (Dean, Education Research)" className="YTB-video" src={personaData.vidUrls[0]} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>
                    </Col>
                    </Row>
                </>)
                break;
            case 2:
                setContent(
                selected===undefined?
                <>
                <Row className="w-100">        
                    <BodyHeader header={personaData.bHeaders[0]}></BodyHeader> 
                </Row>
                <Row className="w-100">  
                    <BodyParagraph paragraph={personaData.bParas[0]}></BodyParagraph>         
                </Row>

                <Row className="w-100 mt-3">        
                    <BodyHeader header={personaData.bHeaders[1]}></BodyHeader> 
                </Row>

                <Row className="w-100">  
                    <BodyParagraph paragraph={personaData.bSubheaders[0]}></BodyParagraph>         
                </Row>

                <Row className="w-100 ">
                    <Col className="d-flex flex-column align-items-center" xs={12}>
                        {impactBoxes}
                    </Col>
                </Row>
            </>
            :
            <>
                <Row className="w-100">        
                    <BodyHeader colClass="p-0" header={personaData.impactsShort[selected]}></BodyHeader> 
                </Row>

                {studyTypeBoxes?
                <>
                    <Row className="mt-3 w-100">
                        {studyTypeCol}
                        <div className="triangle-wrapper" style={{marginLeft:"8.3%",width:`${boxWidth}px`,transform:`translate(${studyTypeBranch*100+studyTypeBranch*15/boxWidth*100}%,3px)`}}>
                            <img alt="triangle" src={triangle.default}></img>
                        </div>
                    </Row>
                </>
                :
                <></>}

                <ResearchImpact
                    className={studyTypeBoxes?"":"mt-4"}
                    studyName={personaData.impactsLong[selected][studyTypeBranch]}
                    author={personaData.authors[selected][studyTypeBranch]} 
                    studyType={personaData.studies[selected][studyTypeBranch]} 
                    why={personaData.why[selected][studyTypeBranch]} 
                    what={personaData.what[selected][studyTypeBranch]}
                    back={reset}
                    >
                    

                </ResearchImpact>

                
            </>
                )
                break;
            default:
                break;
        }
       
    }, [personaKey,personaData,selected,studyTypeBranch,boxWidth]);


    var onClose=()=>{   
        setShow(false);  
        reset();
    }

    useEffect(() => {
        if(show){
            onOpenCallback();
        }
        else{
            onCloseCallback();
        }
        
    }, [show]);

    if(!show){
        return (<></>)
    }
    
    return (<div className={`${isMobile?"research-container-mobile":"research-container"} animate__animated animate__fadeIn animate__faster`}>

        <Overlay  header={personaData.header} subheader={personaData.subheader} onClose={onClose}>
            {content}
        </Overlay>
    
        
    </div>)
}
